<template>
    <!--新增界面-->
    <div v-if="formVisible">
        <el-dialog v-dragDialog :title="formTitle" :visible.sync="formVisible" width="600px"
            :close-on-click-modal="false">
            <el-form :inline="true">
                <el-form-item label="选择成员:">
                    <customerSelector ref="customerSelector" @change="customerChanged" />
                </el-form-item>
                <el-form-item>
                    <el-button type="success" size="small" @click="handleAdd">添加成员</el-button>
                </el-form-item>
            </el-form>
            <el-table size="mini" stripe border :data="groupMembers" highlight-current-row expand-on-click-node="false"
                style="width: 100%" :header-cell-style="{
                    'font-weight': '400',
                    height: '40px',
                    padding: '0',
                    background: '#4a8bc1',
                    color: 'white',
                }">
                <el-table-column type="index" width="30">
                </el-table-column>
                <el-table-column prop="Member.RealName" label="成员名称" min-width="120">
                </el-table-column>
                 <el-table-column prop="Member.Mobile" label="联系方式" min-width="120">
                </el-table-column>
                <el-table-column prop="IsManager" label="是否管理员" min-width="120">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.IsManager" @change="handleManage(scope.row)"/>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="100" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleRemove(scope.row)">移除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>
<script>
import { AddMember, RemoveMember, SetManage, getGroupMembers } from "@/api/traning/runGroup";
import customerSelector from "@/components/customerSelector";
export default {
    components: {
        customerSelector,
    },
    data() {
        return {
            formVisible: false,
            fromTitle: "跑团成员",
            selectCustomer: "",
            groupKey: "",
            groupMembers: [],
        };
    },
    methods: {
        show(row) {
            this.formTitle = "添加跑团";
            this.formVisible = true;
            this.groupKey = row.Key;
            this.loadMembers();
            this.$nextTick(() => {
                this.$refs["dataForm"].clearValidate();
            });
        },
        loadMembers() {
            getGroupMembers({ key: this.groupKey }).then(res => {
                this.groupMembers = res;
            })
        },
        handleAdd() {
            if (this.selectCustomer) {
                let param = { groupKey: this.groupKey, memberKey: this.selectCustomer.Key };
                AddMember(param).then(res => {
                    if (res) {
                        this.msg.successMsg("操作成功");
                        this.loadMembers();
                        this.$emit('update')
                    }
                })
            }
        },
        handleRemove(row) {
            RemoveMember({ key: row.Key }).then(res => {
                if (res) {
                    this.msg.successMsg("操作成功");
                    this.loadMembers();
                    this.$emit('update')
                }
            })
        },
        handleManage(row) {
            SetManage({ key: row.Key, manage: row.IsManager }).then(res => {
                if (res) {
                    this.msg.successMsg("操作成功");
                    this.loadMembers();
                    this.$emit('update')
                }
            })
        },
        customerChanged(v) {
            this.selectCustomer = v;
        },
    },
    mounted() {
    },
};
</script>